import { DATE_FORMAT,TIME_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";
const STATUS = {
  active: "Active",
  inactive: "Inactive",
  blocked: "Blocked",
  deleted: "Deleted",
  pending: "Pending",
}; 
const DoctorColumns = ({
  onCliclNavigate,
  handleViewUser,
  handleEdithandler,
  currentPage,
  pageSize,
  deleteHandler,
  handleUserStatus,
}) => {
  return [
    {
      dataField: "SrNo",
      text: "SrNo",
      formatter: (cell, row, rowIndex) => (
        
        <span className="text-capitalize cursor-pointer">
          {row?.recordid}
        </span>
      ),
    },

    {
      dataField: "first_name",
      text: "Doctor Name",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">{row?.full_name || "--"}</span>
      ),
    },
    {
      dataField: "email1",
      text: "Email",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row?.email || "--"}
        </span>
      ),
    },
    {
      dataField: "phone_no",
      text: "Patient No",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row?.phone_no && row?.country_code
            ? `${row.country_code} ${row.phone_no}`
            : "--"}
        </span>
      ),
    },
    { 
      text: "Appointment Date",
      dataField: "createdAt",
      formatter: (_, row) => row?.appointment_date || "--",
    },
     {
      text: "Appointment Time",
      dataField: "createdAt",
      formatter: (_, row) => row?.appointment_time || "--",
    },
    {
      text: "Status",
      dataField: "status",
      formatter: (_, row) => (
        <span>
          {row?.status && row.status == "5" ? (
            <span className="text  " style={{ background: "", color: "#227fd5" }}>
        Done
      </span>
          ) : (
            <span className="text  " style={{ background: "", color: "#227fd5" }}>
        -
      </span>
          )}
        </span>
      ),
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: (_, row) => (
        <>
         <button
          className="p-2 shadow rounded-2"
          style={{
            fontSize: "12px",
            color: "white",
            backgroundColor: "#227fd5",
            border: "none",
          }}
          title="Record View"
          onClick={() => handleViewUser(row)}
        >
          
          Meeting Record
        </button>                     
        </>
      ),
    },
  ];
};

export default DoctorColumns;
